import React from 'react';
import { PdfDataContext } from './PdfDataContext';

export default function usePdfData() {
  const value = React.useContext(PdfDataContext);
  if (!value) {
    throw new Error('Hook was called before data is loaded.');
  }
  return value;
}
